<button (click)="triggerPrepareDownloadData()"
  [disabled]="isDisabled"
  class="btn btn-outline-primary btn-sm"
  [title]="title"
  type="button">
  <span>
    <span class="fa-solid fa-download"></span>
    @if (label) {
      <span [innerText]="label"></span>
    }
  </span>
</button>